export const PATHNAMES = {
  BASE_WORKSPACE_COMPARE: '/workspace/:panelId/compare',
  BRANDS: '/brands',
  /** @deprecated We're using `PATHNAMES.WORKSPACE_SOA` instead */
  OUTDATED_CATEGORY: '/category',
  COMPARE: '/compare/:tab?',
  DASHBOARDS: '/dashboards',
  DASHBOARDS_FOLDER: '/workspace/:panelId?/dashboards/folder/:folderId',
  ERROR: '/error/:code',
  ERROR_404: '*',
  FLAGS: '/flags',
  GOD_MODE: '/god-mode',
  GROUP_CREATOR: '/group/:groupId/:creatorId/:provider/:tab?/',
  CREATOR: '/creator/:creatorId/:provider/:tab?',
  HOME: '/',
  HOME_PANEL: '/panel/:panelId/:tab?',
  HOME_WORKSPACE: '/workspace/:panelId',
  INDUSTRY_CATEGORY_INITIAL: '/industry-category',
  INDUSTRY_CATEGORY_BASE: '/workspace/:panelId/industry-category',
  INDUSTRY_CATEGORY: '/workspace/:panelId/industry-category/:entityId/:tab?',
  INDUSTRY_CATEGORY_DEMAND_INTELLIGENCE: '/workspace/:panelId/industry-category/:entityId/demand-intelligence',
  JOBS: '/jobs',
  LOGIN: '/login',
  LOGOUT: '/logout',
  MANAGEMENT: '/management/*',
  MANAGEMENT_WORKSPACES: '/management/workspaces',
  MEMBERS_AND_TEAMS: '/members-and-teams',
  MY_ACCOUNT: '/my-account',
  ONBOARDING: '/onboarding',
  GETTING_STARTED: '/getting-started',
  OUTDATED_MEMBERS_MANAGEMENT: '/members-management',
  OUTDATED_REPORTS: '/reports',
  OUTDATED_SAVED_SEARCH: '/saved-search',
  OUTDATED_TRENDING_TAG: '/trending/trending-tag/:entityId?',
  OUTDATED_UNSUBSCRIBE_ALERT: '/unsubscribe-alert',
  OUTDATED_USER_SETTINGS: '/user-settings',
  PUBLIC_ARTIFACT: '/public/artifact/:artifactId',
  PUBLIC_DASHBOARD: '/public/dashboard/:dashboardId',
  REPORTS: '/reports/all',
  REPORTS_ALL: '/reports/all/:postId?',
  REPORTS_CUSTOM: '/reports/custom/:postId?',
  REPORTS_DASHBOARD: '/reports/dashboard/:dashboardId',
  REPORTS_RECURRENT: '/reports/recurrent/:postId?',
  SEARCH: '/search/:tab?/:searchQuery?',
  SEARCH_CREATORS: '/search/creator',
  SEARCH_VIDEOS: '/search/videos',
  SHARED_POST: '/sharedPost',
  /** SoA aka: Share of Attention */
  SOA: '/share-of-attention',
  SUBTOPIC: '/subtopic/:entityId/:tab?',
  TAG: '/tag',
  TAGS: '/tags',
  TOPIC: '/topic/:entityId/:tab?',
  TOPICS: '/topics',
  TOPICS_FAVORITES: '/topics/favorites',
  TOPICS_TYPE: '/topics/:topicsType',
  TRENDING_TAG: '/trending/trending-tag/:entityId/:tab?',
  VIDEO_MODAL: '/post/:provider/:postId',
  WINNIN_REPORT: '/winnin-report',
  WORKSPACE_ARTIFACT: '/workspace/:panelId/artifact/:artifactId',
  WORKSPACE_BRAND: '/workspace/:panelId/brand/:entityId/:tab?',
  WORKSPACE_BRANDS: '/workspace/:panelId/brands/:tab?',
  WORKSPACE_BRANDS_PORTFOLIO_TRACKING: '/workspace/:panelId/brands/portfolio-tracking',
  WORKSPACE_BRAND_GROUP: '/workspace/:panelId/brand-group/:entityId/:tab?',
  WORKSPACE_BRAND_OVERVIEW: '/workspace/:panelId/brand-overview/:entityId/:tab?',
  /** @deprecated We're using `PATHNAMES.WORKSPACE_SOA` instead */
  OUTDATED_WORKSPACE_CATEGORY: '/workspace/:panelId/category',
  /** @deprecated We're using `PATHNAMES.WORKSPACE_SOA_RANKING` instead */
  OUTDATED_WORKSPACE_CATEGORY_RANKING: '/workspace/:panelId/category/ranking',
  WORKSPACE_COMPARE: '/workspace/:panelId/compare/:tab?',
  WORKSPACE_DASHBOARDS: '/workspace/:panelId/dashboards',
  WORKSPACE_JOBS: '/workspace/:panelId/jobs/:jobId/:tab/:folder?/:subTab?',
  WORKSPACE_NICHE: '/workspace/:panelId/niche/:entityId/:tab?',
  /** Scoped Niche Territory route under a Promoted Niche acting as a Category. */
  WORKSPACE_CATEGORY_NICHE: '/workspace/:panelId/category/:categoryId/niche/:entityId/:tab?',
  WORKSPACE_REPORTS: '/workspace/:panelId/reports/:tab?/:postId?',
  WORKSPACE_REPORTS_DASHBOARD: '/workspace/:panelId/reports/dashboard/:dashboardId',
  WORKSPACE_SAVED_SEARCH: '/workspace/:panelId/saved-search/:entityId/:tab?',
  WORKSPACE_SEARCH: '/workspace/:panelId/search/:tab?/:searchQuery?',
  /** SoA aka: Share of Attention */
  WORKSPACE_SOA: '/workspace/:panelId/share-of-attention',
  /** SoA aka: Share of Attention */
  WORKSPACE_SOA_RANKING: '/workspace/:panelId/share-of-attention/ranking',
  WORKSPACE_SUBTOPIC: '/workspace/:panelId/subtopic/:entityId/:tab?',
  WORKSPACE_TAG: '/workspace/:panelId/tag/:entityId/:tab?',
  WORKSPACE_TAGS: '/workspace/:panelId/tags',
  WORKSPACE_LIVE_EVENTS: '/workspace/:panelId/live-events',
  WORKSPACE_LIVE_EVENT: '/workspace/:panelId/live-events/:topicId/:tab?',
  WORKSPACE_TOPIC: '/workspace/:panelId/topic/:entityId/:tab?',
  WORKSPACE_TOPICS: '/workspace/:panelId/topics/:topicsType?',
  WORKSPACE_TRENDING: '/workspace/:panelId/trending/:entityId/:tab?',
  WORKSPACE_HOT_TOPIC: '/workspace/:panelId/hot-topic/:entityId/:tab?',
  WORKSPACE_GLOBAL_TOPIC: '/workspace/:panelId/global-topic/:entityId/:tab?',
  WORKSPACE_THEME: '/workspace/:panelId/theme/:entityId/:tab?',
  WORKSPACE_SEGMENT: '/workspace/:panelId/segment/:entityId/:tab?',
  WORKSPACE_SUBJECT: '/workspace/:panelId/subject/:entityId/:tab?',
  WORKSPACE_ENTITY_QUERY: '/workspace/:panelId/entity-query/:entityId/:tab?',
  WORKSPACE_ENTITY: '/workspace/:panelId/entity/:entityId/:tab?',
  WORKSPACE_TRENDING_TAG: '/workspace/:panelId/trending/trending-tag/:entityId/:tab?',
  WORKSPACE_VIDEO_MODAL: '/workspace/:panelId/post/:provider/:postId',
  WORKSPACE_WINNIN_REPORT: '/workspace/:panelId/winnin-report',
  WORKSPACE_WINNIN_REPORT_CREATE: '/workspace/:panelId/winnin-report/create',
  WORKSPACE_WINNIN_REPORT_DELETE: '/workspace/:panelId/winnin-report/:reportId/delete',
  WORKSPACE_WINNIN_REPORT_EDIT: '/workspace/:panelId/winnin-report/:reportId/edit',
  WORKSPACE_ZAI: '/workspace/:panelId/zai',
  WORKSPACE_ZAI_ANSWER: '/workspace/:panelId/zai/answer',
  WORKSPACE_TRENDS: '/workspace/:panelId/trends/:tab?',
  ZAI: '/zai',
  ZAI_ANSWER: '/zai/answer',
} as const
